<template>
    <div v-if="!needToProcessLogin">
        <v-menu transition="slide-x-reverse-transition" offset-y>      
            <v-toolbar-title slot="activator" class="profile">
                <span class="name hidden-md-and-down">
                {{ name }}       
                </span> 
                <v-btn icon :small="$vuetify.breakpoint.md"  :class="{
                    'smallMargin': $vuetify.breakpoint.md
                }">
                    <v-icon>person</v-icon>
                </v-btn>        
            </v-toolbar-title>
            <v-list dense>
                <v-list-tile @click="goToLocalData">
                    <v-list-tile-title>Local Data</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="signOut()">
                    <v-list-tile-title>Sign Out</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>    
    </div>   
</template>

<script>
export default {
    name: 'profile',
    computed: {
        needToProcessLogin: function () {
            return !this.$store.getters["UserStore/isLoaded"];
        },
        name: function () {
            return this.$store.getters["UserStore/getFullName"];
        },
    },
    methods: {
        goToLocalData(){
            this.$router.push({
                name: "localData"
            });
        },
        signOut () {
            this.$router.push({
                path: "/logout"
            });
        }
    }
}
</script>

<style scoped>
.name {
    font-size: 13px;
    padding-left: 10px
}
.smallMargin {
    margin: 0px;
}
</style>